import { Link } from "react-router-dom";
import { getAllPosts } from "../lib/blog";
import { siteConfig } from "../integrations/site.config";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function BlogIndexPage() {
  useDocumentTitle(`${siteConfig.blog.title} — Pilot Mastery Academy`);
  const posts = getAllPosts();

  return (
    <div className="mx-auto max-w-5xl px-4 py-16">
      <p className="text-sm font-medium uppercase tracking-wider text-signal-sky">{siteConfig.blog.title}</p>
      <h1 className="mt-2 font-display text-4xl font-semibold text-white">Articles & updates</h1>
      <p className="mt-4 max-w-2xl text-slate-400">
        Evidence-based guides on pilot finances, decision-making, and career transitions. Built for professional pilots who want flight-deck clarity.
      </p>
      <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <li key={post.slug} className="flex flex-col overflow-hidden rounded-xl border border-white/10 bg-deck-panel/60 shadow-lift backdrop-blur-sm">
            <Link to={`/blog/${post.slug}`} className="group flex flex-col h-full">
              {post.meta.featuredImage && (
                <img
                  src={post.meta.featuredImage}
                  alt={post.meta.imageAlt || post.meta.title}
                  className="h-44 w-full object-cover"
                />
              )}
              <div className="flex flex-1 flex-col p-5">
                <time className="text-xs text-slate-500">{post.meta.date}</time>
                <h2 className="mt-2 font-display text-lg font-semibold leading-snug text-white group-hover:text-signal-sky">
                  {post.meta.title}
                </h2>
                <p className="mt-2 flex-1 text-sm text-slate-400 line-clamp-3">{post.meta.description}</p>
                {post.meta.tags && post.meta.tags.length > 0 && (
                  <p className="mt-3 text-xs text-slate-600">{post.meta.tags.join(" · ")}</p>
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
      {posts.length === 0 && (
        <p className="mt-8 text-slate-500">No posts yet. Add markdown files under content/blog/.</p>
      )}
    </div>
  );
}
